import React from "react";
import { Link } from "react-router-dom";
import Modal from "../Modal";

const Profile = ({comment, description, emailId, link, phone, phoneDisplay, occupation, title}) => {
  return (
    <div>
      <h5>
        {title} <span>{occupation}</span>
      </h5>
      <p>
       {description}
        <br />
        <Link
          to="#"
          className="link-more"
          data-toggle="modal"
          data-target={link}
        >
          View Profile
        </Link>
      </p>
      <Modal comment={comment} emailId={emailId} occupation={occupation} phone={phone} phoneDisplay={phoneDisplay} title={title} />
    </div>
  );
};

export default Profile;
